import React from 'react';
import { connect } from 'react-redux';
import { selectors as i18nSelectors } from 'mage-i18n';
import { Currency } from '@/bpc/mf-fields/enm/Currency';
import { roundPreDecimals } from '@/bpc/utils/math';
export const _BusinessSizeLabel = ({ currencyFormatterFactory, currency = Currency.SEK, from, to, rate = 1, t, }) => {
    const tPrefix = 'products-fe.containers.volume_separation';
    const currencyFormatter = (value) => currencyFormatterFactory(currency, true).format(roundPreDecimals(value * rate, 1));
    if (from && to) {
        return (React.createElement(React.Fragment, null, t(`${tPrefix}.between`, {
            belowThreshold: currencyFormatter(from),
            aboveThreshold: currencyFormatter(to),
        })));
    }
    if (from && !to) {
        return (React.createElement(React.Fragment, null, t(`${tPrefix}.over`, {
            threshold: currencyFormatter(from),
        })));
    }
    if (!from && to) {
        return (React.createElement(React.Fragment, null, t(`${tPrefix}.below`, {
            threshold: currencyFormatter(to),
        })));
    }
    return null;
};
export const BusinessSizeLabel = connect(state => ({
    currencyFormatterFactory: i18nSelectors.formatters.currency(state),
}))(_BusinessSizeLabel);
